<app-menu *ngIf="!auth.isAuthenticated()"></app-menu><div *ngIf="!auth.isAuthenticated()"><br><br><br><br></div>
<link href="//fonts.googleapis.com/css?family=Playfair+Display:400,400i,700,700i,900" rel="stylesheet">
<link href="//fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700" rel="stylesheet">
<div class="row mt-5 mb-5 ml-4 mr-4 position-relative p-5" style="background-color: rgba(255, 255, 255, 0.9); border-radius: 10px">
  <div class="filter-bar col-md-3 p-5" style="border-radius: 30px; background-color: rgba(255, 255, 255, 0.9); height: fit-content">
    <p class="text-center"><i class="material-icons text-primary" style="font-size: 80px">filter_alt</i></p>
    <div class="filter_type">
      <h6 class="text-primary"><i class="icon-search"></i> Keyword</h6>
      <input [(ngModel)]="filters.keyword" (keyup)="getAnnoncesByFilters()" name="status" type="text"
             class="form form-control text-rose"
             placeholder="Enter your Keyword..."
      />
    </div>
    <br>
    <div class="filter_type">
      <h6 class="text-primary"><i class="icon-list"></i>Status</h6>
      <select [(ngModel)]="filters.status" (change)="getAnnoncesByFilters()" class="form form-control text-rose">
        <option value="" selected>tout</option>
        <option value="Location">Location</option>
        <option value="Vente">Vente</option>
      </select>

    </div>
    <br>
    <div class="filter_type">
      <h6 class="text-primary"><i class="icon-graduation-cap"></i>Categorie</h6>
      <select [(ngModel)]="filters.type" (change)="getAnnoncesByFilters()"
              class="form form-control text-rose">
        <option value="">Tout les catégories</option>
        <option value="Maison">Maison</option>
        <option value="Appartement">Appartement</option>
        <option value="Terrain">Terrain</option>
        <option value="Café">Café</option>
        <option value="Garage">Garage</option>
        <option value="Usine">Usine</option>
        <option value="Immeuble">Immeuble</option>
        <option value="Maison de village">Maison de village</option>
      </select>
    </div>
    <br>
    <div class="filter_type">
      <h6 class="text-primary"><i class="icon-graduation-cap"></i>Ville</h6>
      <select [(ngModel)]="filters.city" (change)="getAnnoncesByFilters()"
              class="form form-control text-rose">
        <option value="">Toutes les villes</option>
        <option *ngFor="let city of cities" [value]="city">
          {{city}}
        </option>
      </select>
    </div>
    <br>
    <div class="filter_type">
      <h6 class="text-primary"><i class="icon-graduation-cap"></i>Surface (m2)</h6>
      <input class="form form-control text-rose" type="text" name="" [(ngModel)]="filters.surface" (change)="getAnnoncesByFilters()">
    </div>
    <br>
    <div class="filter_type row">
      <div class="col-md-6">
        <h6 class="text-primary"><i class="icon-graduation-cap"></i>Budget min</h6>
        <input class="form form-control text-rose" min="1" type="number" name="" [(ngModel)]="filters.budget_min"
               (change)="getAnnoncesByFilters()">
      </div>
      <div class="col-md-6">
        <h6 class="text-primary"><i class="icon-graduation-cap"></i>Budget max</h6>
        <input class="form form-control text-rose" min="1" type="number" name="" [(ngModel)]="filters.budget_max"
               (change)="getAnnoncesByFilters()">
      </div>
    </div>
    <br>
    <div class="filter_type">
      <h6 class="text-primary"><i class="icon-graduation-cap"></i>Nbr Pieces</h6>
      <input class="form form-control text-rose" type="number" min="1" name="" [(ngModel)]="filters.pieces"
             (change)="getAnnoncesByFilters()">
    </div>
    <div class="button-container pt-5 mt-5 text-center">
      <button class="btn btn-primary" routerLink="/">Go Back</button>
      <button class="btn btn-primary" (click)="goToMap()">Go To Map</button>
    </div>
  </div>
  <div class="col-md-9">
    <!--    <div id="gridCards" class="mt-5 mb-5 ml-4 mr-4">-->
    <div class="container">
      <div class="row">
        <div class="col-md-4" *ngFor="let a of annonces">
          <app-card-announce [id]="a.id" [title]="a.title" [description]="a.description" [city]="a.city" [price]="a.price" [images]="a.images" [created_at]="a.created_at"></app-card-announce>
        </div>
      </div>
    </div>
    <!--<div class="row">
      <div class="col-md-4 mb-4 h-200" *ngFor="let a of annonces">
        <div class="card">
          <img class="card-img-top img-dim" src="../../assets/pictures/home/pic1.jfif" alt="Card image cap">
          <div class="card-body">
            <h5 class="card-title">{{a.title}}</h5>
            <p class="card-text">{{a.description}}</p>
            <p class="card-text"><small class="text-muted">date : {{a.created_at.split(' ')[0]}}</small></p>
            <a href="#" class="btn btn-primary stretched-link">Voir plus</a>
          </div>
        </div>
      </div>
    </div>-->
    <!--    </div>-->
  </div>
</div>
<app-footer *ngIf="!auth.isAuthenticated()"></app-footer>
